import React, { ReactNode } from "react";
import { RightSidebar } from "src/components";
type AllProps = {
  children: ReactNode;
  className?: string;
}

function DefaultTemplate(props: AllProps) {
  const { className, children } = props;
  return <>
    <RightSidebar />
    <div className={`content-wrapper${!!className ? ` ${className}` : ""}`}>{children}</div>
  </>;
}

export default React.memo(DefaultTemplate);
